; (function ($) {

	$(document).ready(function () {
		toggleSections();

		$("#application-form").validate({
			rules: {
				effective_date: 'required',
				requested_by: 'required',
				approved_by: 'required',
				'construction_materials[]': 'required',
				tot_sq_ft: 'required',
				year_built: 'required',
				application_leased_building: 'required',
				three_stories: 'required',
				sprinkler_system: 'required',
				flood_zone: 'required',
				total_project_cost: 'required',
				new_contents_value: 'required',
				rm_total_project_cost: 'required',
				rm_new_contents_value: 'required',
				rm_new_tot_sq_ft: 'required',
				deletion_reason: 'required',
				other_contents_value: 'required',
				contents_value: 'required',
				vehicle_category: 'required',
				vehicle_value: 'required',
				vehicle_cost_perm_equip: 'required',
				vehicle_make_model: 'required',
				vehicle_vin: 'required',
				vehicle_use_location: 'required',
				expenditures_change: 'required'
			},
			groups: {
				'materials-group': 'construction_materials[]'
			},
			messages: {
				'materials-group': {
					required: 'Choose at least one material'
				}
			},	// end messages
			errorPlacement: function (error, element) {
				if (element.attr("name") == 'construction_materials[]') {
					error.appendTo("#materials_error");
				} else {
					error.appendTo(element);
				}
			},
			submitHandler: function (form) {
				// console.log("Send It");
				form.submit();
			}
		});

	});



	$(window).load(function () {

	});

	$(window).resize(function () {

	});


	//show Application Ammendment vehicle section
	function toggleSections() {
		//Property Section
		$('#property_options_1, #property_options_2, #property_options_3').click(function () {
			if ($(this).is(':checked')) {
				$('.application-property-section').fadeIn();
			} else {
				$('.application-property-section').fadeOut();
			}
		});

		$('input[name="deductible"]').click(function () {
			if ($(this).hasClass('property-deductible-other')) {
				$('div.property-deductibles-label').show();
				$('div.property-deductibles-list').show();
			} else {
				$('div.property-deductibles-label').hide();
				$('div.property-deductibles-list').hide();
			}
		});

		//Other Property Section
		$('#other_addition, #other_deletion').click(function () {
			$(this).parents('.radio-field').siblings('.radio-field').children('label').children('input').prop('checked', false);

			if ($(this).is(':checked')) {
				$('.application-other-property-section').fadeIn();
			} else {
				$('.application-other-property-section').fadeOut();
			}
		});

		$('input[name="deletion_reason"]').click(function () {
			if (this.value == "other") {
				$('div.deletion-other-description').show();
			} else {
				$('div.deletion-other-description').hide();
			}
		});

		//Golf
		//Other Property Section
		$('#non-golf, #golf').click(function () {
			$(this).parents('.radio-field').siblings('.radio-field').children('label').children('input').prop('checked', false);

			if (this.value == "non-golf-type") {
				$('.application-other-property-section div.non-golf').fadeIn();
				$('.application-other-property-section div.golf').fadeOut();
			} else {
				$('.application-other-property-section div.non-golf').fadeOut();
				$('.application-other-property-section div.golf').fadeIn();
			}
		});


		//Separately-Rated Exposures Section
		$('#gen_liability_add, #gen_liability_del').click(function () {
			$(this).parents('.radio-field').siblings('.radio-field').children('label').children('input').prop('checked', false);
			if ($(this).is(':checked')) {
				$('.application-exposures-section').fadeIn();
			} else {
				$('.application-exposures-section').fadeOut();
			}
		});

		//Vehicle Section
		$('#vehicle_add, #vehicle_delete').click(function () {
			if ($(this).is(':checked')) {
				$(this).parents('.radio-field').siblings('.radio-field').children('label').children('input').prop('checked', false);
				$('.application-vehicle-section').fadeIn();
			} else {
				$('.application-vehicle-section').fadeOut();
			}
		});

		$('input[name="vehicle_add_delete"]').click(function () {
			if (this.value == "add") {
				$('div.auto-adding-row').show();

			} else {
				$('div.auto-adding-row').hide();
			}
		});

		$('input[name="auto_physical_damage_type"]').click(function () {
			if (this.value == "Other") {
				$('div.auto-deductible').show();
			} else {
				$('div.auto-deductible').hide();
			}
		});



		//Law Section
		$('#le_add, #le_delete').click(function () {
			$(this).parents('.radio-field').siblings('.radio-field').children('label').children('input').prop('checked', false);
			if ($(this).is(':checked')) {
				$('.application-law-section').fadeIn();
			} else {
				$('.application-law-section').fadeOut();
			}
		});


		//Other Section
		$('#other_activity_add, #other_activity_del').click(function () {
			if ($(this).is(':checked')) {
				$('.application-other-section').fadeIn();
			} else {
				$('.application-other-section').fadeOut();
			}
		});

		// Remodeled Existing Building Section
		$('#application_remodeled_existing_building').click(function () {
			if ($(this).is(':checked')) {
				$('.remodel-property-section').fadeIn();
			} else {
				$('.remodel-property-section').fadeOut();
			}
		});

		// Delete Building Section
		$('#delete_building').click(function () {
			if ($(this).is(':checked')) {
				// console.log('yes')
				$('.delete-property-section').fadeIn();
			} else {
				// console.log('no')
				$('.delete-property-section').fadeOut();
			}
		});

		$('input.construction_materials').change(function () {
			// When a checkbox is selected, deselect the others
			if ($(this).is(':checked')) {
				$('.construction_materials').not(this).prop('checked', false);
			}
		});

		// Add/Remove Contents of Existing Building Section
		$('#delete_decrease_contents').click(function () {
			if ($(this).is(':checked')) {
				// console.log('yes')
				$('.edit-contents-section').fadeIn();
			} else {
				// console.log('no')
				$('.edit-contents-section').fadeOut();
			}
		});

	}
	$(document).ready(function () {
		// Add input event listener for elements with the class "money"
		$('.formatnumber').on('input', function () {
			// Remove non-numeric characters
			var value = $(this).val().replace(/[^0-9]/g, '');

			// Format the value with commas
			var formattedValue = Number(value).toLocaleString();

			// Update the input value
			$(this).val(formattedValue);
		});

		$('.money').on('input', function () {
			// Remove non-numeric characters
			var value = $(this).val().replace(/[^0-9]/g, '');

			// Format the value with commas and add "$" sign
			var formattedValue = '$' + Number(value).toLocaleString();

			// Update the input value
			$(this).val(formattedValue);
		});
	});

})(jQuery);